export default function renderAdrTaHeaderV3(data) {
  return function (pdf) {
    let cursorY = this.cursorY;
    let cursorX = 0;

    // Title block
    const bottomOfHeader = 52;
    pdf.setFontSize(8).setFont("helvetica", "normal");
    pdf.text("STATE OF CALIFORNIA - DEPARTMENT OF TRANSPORTATION", 15, 25);
    pdf.setFontSize(13).setFont("helvetica", "bold");
    pdf.text("TENTATIVE DAILY EXTRA WORK AGREEMENT", 15, 38);
    pdf.setFontSize(8).setFont("helvetica", "normal");
    pdf.text("CEM-4907 (CT ProDMS v" + data.version + ")", 15, 48);
    pdf.line(15, bottomOfHeader, 590, bottomOfHeader);
    pdf.line(15, bottomOfHeader + 2, 590, bottomOfHeader + 2);
    cursorY = 50;

    // Header
    const headerLine1_y = 68;
    pdf.setFontSize(10).setFont("helvetica", "normal");
    pdf.text("CONTRACT NO.:", 17, headerLine1_y);
    pdf.text(data.fullEA, 98, headerLine1_y);
    pdf.text("CHANGE ORDER NO.:", 250, headerLine1_y);
    pdf.text("DATE:", 430, headerLine1_y);
    pdf.line(15, headerLine1_y + 4, 590, headerLine1_y + 4);

    const headerLine2_y = 86;
    pdf.text("WORK PERFORMED BY:", 17, headerLine2_y);
    pdf.text(data.contractors.join(", "), 137, headerLine2_y);
    pdf.line(15, headerLine2_y + 4, 590, headerLine2_y + 4);

    const headerLine3_y = 104;
    pdf.text("WORK DESCRIPTION:", 17, headerLine3_y);
    pdf.text(data.workDescription, 130, headerLine3_y);
    pdf.line(15, headerLine3_y + 4, 590, headerLine3_y + 4);

    const headerLine4_y = 122;
    pdf.text("WORK LOCATION:", 17, headerLine4_y);
    pdf.text("test", 120, headerLine4_y);
    pdf.line(15, headerLine4_y + 4, 590, headerLine4_y + 4);

    this.cursorY = 126;
  };
}
